import builder from '../builder';
import PhoneActionsRing from '../../streamline-icons/light/phone-actions-ring.svg';

export default builder('IconPhoneActionsRingLight', PhoneActionsRing);
